import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import NewsTileCard, { NewsTileStyles } from "@ucs/Components/News/NewsTileCard";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    image = "image",
    date = "date",
    newsTitle = "newsTitle",
    newsLink = "newsLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.date]: Date;
        [fields.newsTitle]: string;
        [fields.newsLink]: LinkFieldValue;
    };
}

type Props = OwnProps;

export const newsStyles: NewsTileStyles = {};

const styles = newsStyles;

const NewsTile: React.FC<Props> = ({ fields }) => {
    const newsLink = useGetLink(fields.newsLink);
    const { image, newsTitle, date } = fields;
    return (
        <NewsTileCard
            image={image}
            newsLink={newsLink.url || ""}
            newsTitle={newsTitle}
            date={date}
            extendedStyles={styles}
        />
    );
};

const widgetModule: WidgetModule = {
    component: NewsTile,
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.image,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.date,
                editorTemplate: "DateTimeField",
                defaultValue: null,
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.newsTitle,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.newsLink,
                editorTemplate: "LinkField",
                defaultValue: {
                    value: "",
                    type: "Page",
                },
                fieldType: "General",
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
